import style from "./AccountSubscription.module.scss";
import AccountHeader from "./AccountHeader";
import { useState, useEffect } from "react";
import { selectID } from "../../features/counter/counterSlice";
import { useSelector } from "react-redux";
import { apiService } from "../../api/dataverseApi";
import { formatExpiryDate } from "../../features/userProfile/mySubscriptions";
import { Button } from "../Button/Button";

const AccountSubscriptions = () => {
  const [profileData, setProfileData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const authID = useSelector(selectID);

  const shouldShowRenewButton = (expiryDateStr) => {
    if (!expiryDateStr) return false;

    try {
      const expiry = new Date(expiryDateStr);
      const now = new Date();
      const fourMonthsFromNow = new Date(now);
      fourMonthsFromNow.setMonth(now.getMonth() + 4);
      return expiry <= fourMonthsFromNow;
    } catch (error) {
      console.error("Error parsing date:", error);
      return false;
    }
  };

  const fetchUserProfile = async () => {
    setLoading(true);
    setError(null);

    try {
      if (!authID?.u?.["signInNames.emailAddress"]) {
        throw new Error("User email not available");
      }

      const email = authID.u["signInNames.emailAddress"];
      const response = await apiService.getUserProfile(email);

      if (response.success) {
        setProfileData(response.data);
      } else {
        throw new Error(response.message || "Failed to fetch profile data");
      }
    } catch (err) {
      console.error("Profile fetch error:", err);
      setError(err.message || "An error occurred while fetching profile data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (authID?.u) {
      fetchUserProfile();
    } else {
      setLoading(false);
    }
  }, [authID]);

  const handleRetry = () => {
    fetchUserProfile();
  };

  const handleRenew = () => {
    // Implement renew functionality
    console.log("Renew subscription clicked");
  };

  if (loading) {
    return (
      <div className={style.accountContainer}>
        <AccountHeader headername="Subscriptions" />
        <div className={style.loaderContainer}>
          <div className={style.loader}></div>
          <p>Loading subscription data...</p>
        </div>
      </div>
    );
  }

  return (
    <div className={style.accountContainer}>
      <AccountHeader headername="Subscriptions" />
      <div className={style.subscriptionContainer}>
        <p className={style.title}>Subscription summary</p>

        {error ? (
          <div className={style.errorContainer}>
            <p className={style.errorMessage}>{error}</p>
            <Button onClick={handleRetry} type="black">
              Retry
            </Button>
          </div>
        ) : (
          <div className={style.subscriptionCard}>
            <div className={style.subscriptionRow}>
              <span className={style.subscriptionLabel}>Products:</span>
              <span className={style.subscriptionValue}>
                Therapeutic Guidelines
              </span>
            </div>

            {profileData?.subscriptions?.tg_expirydate && (
              <div className={style.subscriptionRow}>
                <span className={style.subscriptionLabel}>Expiry:</span>
                <span className={style.subscriptionValue}>
                  {formatExpiryDate(profileData.subscriptions.tg_expirydate)}
                </span>
              </div>
            )}

            <p className={style.subscriptionNote}>
              If you want to purchase/renew an account with more than 1 licence,
              please contact our Sales Team at{" "}
              <a href="mailto:sales@tg.org.au" className={style.emailLink}>
                sales@tg.org.au
              </a>{" "}
              or call us on +61 3 9329 1566
            </p>

            {profileData?.subscriptions?.tg_expirydate &&
              shouldShowRenewButton(
                profileData.subscriptions.tg_expirydate,
              ) && (
                <Button
                  type="black"
                  onClick={handleRenew}
                  className={style.renewButton}
                >
                  Renew subscription
                </Button>
              )}
          </div>
        )}
      </div>
    </div>
  );
};

export default AccountSubscriptions;
